// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargePropertyChangeDisplayType {
  None = "NONE",
  LicensePlateChangeBeforeValidity = "LICENSE_PLATE_CHANGE_BEFORE_VALIDITY",
  CountryChangeBeforeValidity = "COUNTRY_CHANGE_BEFORE_VALIDITY",
  ValidSinceChangeBeforeValidity = "VALID_SINCE_CHANGE_BEFORE_VALIDITY",
  LicensePlateChangeDuringValidity = "LICENSE_PLATE_CHANGE_DURING_VALIDITY",
  CountryChangeDuringValidity = "COUNTRY_CHANGE_DURING_VALIDITY",
  SingleLicensePlateChange = "SINGLE_LICENSE_PLATE_CHANGE",
  SingleCountryChange = "SINGLE_COUNTRY_CHANGE",
  BulkLicensePlateChange = "BULK_LICENSE_PLATE_CHANGE",
  BulkCountryChange = "BULK_COUNTRY_CHANGE",
  LicensePlateChangeInDistributorLimit = "LICENSE_PLATE_CHANGE_IN_DISTRIBUTOR_LIMIT",
  CountryChangeInDistributorLimit = "COUNTRY_CHANGE_IN_DISTRIBUTOR_LIMIT",
  ValidSinceChangeInDistributorLimit = "VALID_SINCE_CHANGE_IN_DISTRIBUTOR_LIMIT",
  EmailNotificationChange = "EMAIL_NOTIFICATION_CHANGE",
  SmsNotificationChange = "SMS_NOTIFICATION_CHANGE",
  NotificationEmailAddressChange = "NOTIFICATION_EMAIL_ADDRESS_CHANGE",
  NotificationPhoneNumberChange = "NOTIFICATION_PHONE_NUMBER_CHANGE",
  CustomerRefund = "CUSTOMER_REFUND",
  DistributorRefund = "DISTRIBUTOR_REFUND",
  FuelTypeChangeWithPartialRefund = "FUEL_TYPE_CHANGE_WITH_PARTIAL_REFUND",
  FuelTypeChange = "FUEL_TYPE_CHANGE",
  EmailAddressChange = "EMAIL_ADDRESS_CHANGE",
  PriceChange = "PRICE_CHANGE",
  VehicleRegisterVehicleIdChange = "VEHICLE_REGISTER_VEHICLE_ID_CHANGE",
  VehicleRegisterSynchronizationStatusChange = "VEHICLE_REGISTER_SYNCHRONIZATION_STATUS_CHANGE",
  VehicleRegisterVehiclePropertiesChange = "VEHICLE_REGISTER_VEHICLE_PROPERTIES_CHANGE",
}
export default ChargePropertyChangeDisplayType;
